<ng-container *ngIf="mortgageApplication?.IsFullApp">
  <boi-form-address [mortgageApplication]="mortgageApplication" [(address)]="mortgageApplication.PropertyAddress"
    [labelName]="referenceDataLabels.PropertyAddress" [addressLine1Required]="true" [propertyName]="'PropertyAddress'"
    [forcePostcodeNotRequired]="true" [showCountryCode]="false"  [hideFindAddress]="false"
    [isFindAddressButtonDisabled]="mortgageApplication?.IsApplicationReadOnly">
  </boi-form-address>
</ng-container>

<ng-container *ngIf="mortgageApplication.isRemortgage">
  <boi-form-date [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
  [labelName]="referenceDataLabels.PurchaseDateOfPropertyRemortgaging"
    [(value)]="mortgageApplication.PurchaseDateOfPropertyRemortgaging"
    [propertyNames]="['PurchaseDateOfPropertyRemortgaging']">
  </boi-form-date>

  <ng-container *ngIf="!mortgageApplication.IsFactFind">
    <boi-form-numeric-input [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly" [isCurrency]="true" [labelName]="referenceDataLabels.OriginalPricePaidForTheProp"
      [(value)]="mortgageApplication.PropertyOriginalPrice" [propertyNames]="['PropertyOriginalPrice']"
      [fieldMaxLength]="8" [fieldMinValue]="1" [fieldMaxValue]="10000000">
    </boi-form-numeric-input>
  </ng-container>
</ng-container>

<!--180.1-->
<ng-container *ngIf="(mortgageApplication.IsFactFind || mortgageApplication.IsAip) && mortgageApplication.isPurchase">
  <boi-form-radio-button [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
     [labelName]="referenceDataLabels.PropertyDetailsForApplication"
    [propertyNames]="['KnowPropertyDetailsCode']" [optionList]='referenceDataOptionLists.AnswerType'
    [(value)]="mortgageApplication.KnowPropertyDetailsCode"></boi-form-radio-button>
</ng-container>

<!--180.2-->
<ng-container *ngIf="mortgageApplication.isScottishPropertyAndFullApplication">
  <boi-form-date [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || mortgageApplication?.IsFactFindReadOnly"
  [labelName]="referenceDataLabels.DateOfEntry" [propertyNames]="['DateOfEntry']"
  [(value)]="mortgageApplication.DateOfEntry"></boi-form-date>
</ng-container>

<!--181-->
<ng-container *ngIf="mortgageApplication.arePropertyDetailsVisibleIncludingFactFind()">
  <boi-form-option-list [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || (mortgageApplication?.IsFactFindReadOnly && mortgageApplication.IsFactFind)"
    [optionList]="referenceDataOptionLists.PropertyType"
    [labelName]="referenceDataLabels.WhatTypeOfPropertyIsIt" [propertyNames]="['PropertyTypeCode']"
    [(value)]="mortgageApplication.PropertyTypeCode"
    (valueChange)="mortgageApplication.nullifyFlatDetailsRelatedFields()"></boi-form-option-list>
</ng-container>

<ng-container *ngIf="mortgageApplication.areFlatDetailsVisible() && !mortgageApplication.IsFactFind">
  <!--182-->
  <boi-form-numeric-input [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly" [labelName]="referenceDataLabels.HowManyStoreysAreThereInBlock"
    [propertyNames]="['NumberOfStoreys']" [(value)]="mortgageApplication.NumberOfStoreys" [fieldMaxLength]="2">
  </boi-form-numeric-input>

  <!--183-->
  <boi-form-numeric-input [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly" [labelName]="referenceDataLabels.WhatFloorIsTheFlatOn" [propertyNames]="['FloorNo']"
    [(value)]="mortgageApplication.FloorNo" [fieldMaxLength]="2"></boi-form-numeric-input>

  <!--184-->
  <boi-form-radio-button [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly" [labelName]="referenceDataLabels.IsThePropertySituatedAbove"
    [propertyNames]="['AboveCommercialPremisesCode']" [optionList]='referenceDataOptionLists.AnswerType'
    [(value)]="mortgageApplication.AboveCommercialPremisesCode"></boi-form-radio-button>
</ng-container>

<!--186-->
<ng-container *ngIf="mortgageApplication.arePropertyDetailsVisibleIncludingFactFind()">
  <boi-form-option-list [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || (mortgageApplication?.IsFactFindReadOnly && mortgageApplication.IsFactFind)"
    [optionList]='referenceDataOptionLists.TenureType' [propertyNames]="['OwnershipTypeCode']"
    [labelName]='referenceDataLabels.WhatIsTheTenure' [(value)]='mortgageApplication.OwnershipTypeCode'
    [contextualHelpName]="'AppTenureType'" (valueChange)="mortgageApplication.nullifySubjectToLeaseCode()">
  </boi-form-option-list>
</ng-container>

<!--187-->
<ng-container *ngIf="mortgageApplication.isSubjectToLeaseVisible() && !mortgageApplication.IsFactFind">
  <boi-form-radio-button [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly" [optionList]='referenceDataOptionLists.AnswerType'
    [labelName]='referenceDataLabels.IsItSubjectToALease' [propertyNames]="['SubjectToLeaseCode']"
    [(value)]='mortgageApplication.SubjectToLeaseCode'></boi-form-radio-button>
</ng-container>

<!--188-->
<ng-container *ngIf="mortgageApplication.isRemainingLeasePeriodVisible()">
  <boi-form-numeric-input [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly || (mortgageApplication?.IsFactFind && mortgageApplication?.IsFactFindReadOnly)"
    [labelName]='referenceDataLabels.WhatIsTheRemainingLeasePeriod'
    [propertyNames]="['RemainingLease']" [(value)]="mortgageApplication.RemainingLease" [fieldMaxLength]="3">
  </boi-form-numeric-input>
</ng-container>

<!--195-->
<ng-container *ngIf="mortgageApplication.IsFullApp">
  <boi-form-numeric-input [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly" [labelName]='referenceDataLabels.NumberOfBedrooms' [propertyNames]="['NumberOfBedrooms']"
    [(value)]="mortgageApplication.NumberOfBedrooms" [fieldMaxLength]="2" [fieldMinValue]="0" [fieldMaxValue]="99"></boi-form-numeric-input>
</ng-container>

<!--200-->
<ng-container *ngIf="mortgageApplication.arePropertyDetailsVisible()">
  <boi-form-option-list [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly" [optionList]='referenceDataOptionLists.PropertyConstructionPeriod'
    [propertyNames]="['PropertyYearOfConstructionCode']" [labelName]="referenceDataLabels.WhenWasThePropertyConstructed"
    [(value)]="mortgageApplication.PropertyYearOfConstructionCode"></boi-form-option-list>
</ng-container>

<!--203-->
<ng-container *ngIf="mortgageApplication.arePropertyDetailsVisible()">
  <boi-form-radio-button [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly" [optionList]='referenceDataOptionLists.AnswerType'
    [labelName]='referenceDataLabels.IsThePropertyExPublicSector' [propertyNames]="['ExGovernmentCode']"
    [(value)]='mortgageApplication.ExGovernmentCode' [contextualHelpName]="'AppPropertyExPublicSector'">
  </boi-form-radio-button>
</ng-container>

<ng-container *ngIf="mortgageApplication.IsFullApp">
  <!--208-->
  <boi-form-radio-button [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly" [optionList]='referenceDataOptionLists.AnswerType'
    [labelName]='referenceDataLabels.WillThePropertyUsedForBusiness' [propertyNames]="['ForBusinessPurposesCode']"
    [(value)]='mortgageApplication.ForBusinessPurposesCode'></boi-form-radio-button>

  <!--208.1-->
  <ng-container *ngIf="mortgageApplication.ForBusinessPurposesCode === referenceDataOptionLists.AnswerTypeYes">
    <boi-form-textarea [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly" [labelName]='referenceDataLabels.PleaseProvideDetails'
      [propertyNames]="['ForBusinessPurposesDetails']" [fieldMaxLength]="1500"
      [(value)]='mortgageApplication.ForBusinessPurposesDetails'>
    </boi-form-textarea>
  </ng-container>
</ng-container>

<ng-container *ngIf="mortgageApplication.IsFullApp">
  <ng-container *ngIf="mortgageApplication.isBuyToLet">
    <boi-form-radio-button [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly" [optionList]='referenceDataOptionLists.AnswerType'
      [labelName]='referenceDataLabels.IsSingleFamilyPropertyCode' [propertyNames]="['IsSingleFamilyPropertyCode']"
      [(value)]='mortgageApplication.IsSingleFamilyPropertyCode'></boi-form-radio-button>

    <ng-container *ngIf="mortgageApplication.IsSingleFamilyPropertyCode === referenceDataOptionLists.AnswerTypeNo">
      <boi-form-radio-button [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly" [optionList]='referenceDataOptionLists.AnswerType'
        [labelName]='referenceDataLabels.IsHMOLicenceRequiredCode' [propertyNames]="['IsHMOLicenceRequiredCode']"
        [(value)]='mortgageApplication.IsHMOLicenceRequiredCode'></boi-form-radio-button>
    </ng-container>

    <boi-form-numeric-input [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly" [propertyNames]="['NoPeopleOnTenancyAgreement']"
      [labelName]="referenceDataLabels.NoPeopleOnTenancyAgreement"
      [(value)]="mortgageApplication.NoPeopleOnTenancyAgreement" [fieldMaxLength]="2"></boi-form-numeric-input>

    <boi-form-radio-button [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly" [optionList]='referenceDataOptionLists.AnswerType'
      [labelName]='referenceDataLabels.PleaseTellUsIfLetToRelatice' [propertyNames]="['PropertyLetToRelativeCode']"
      [(value)]='mortgageApplication.PropertyLetToRelativeCode'></boi-form-radio-button>

    <boi-form-radio-button [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly" [optionList]='referenceDataOptionLists.AnswerType'
      [labelName]='referenceDataLabels.WillThereBeAnyExistingTenants'
      [propertyNames]="['PropertyTenantsOnCompletionCode']"
      [(value)]='mortgageApplication.PropertyTenantsOnCompletionCode'></boi-form-radio-button>
  </ng-container>

  <ng-container *ngIf="mortgageApplication.PropertyTenantsOnCompletionCode === referenceDataOptionLists.AnswerTypeYes">
    <boi-form-date [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly" [labelName]="referenceDataLabels.DateFirstTenantOccupiedTheProperty"
      [(value)]="mortgageApplication.DateFirstTenantOccupiedTheProperty"
      [propertyNames]="['DateFirstTenantOccupiedTheProperty']"></boi-form-date>

    <boi-form-date [labelName]="referenceDataLabels.DateTenacyAgreementFinishes"
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [(value)]="mortgageApplication.DateTenacyAgreementFinishes" [propertyNames]="['DateTenacyAgreementFinishes']">
    </boi-form-date>

    <boi-form-numeric-input [isCurrency]="true" [propertyNames]="['MonthlyRentCurrentlyPaidByTenants']"
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [labelName]="referenceDataLabels.MonthlyRentCurrentlyPaidByTenants"
      [(value)]="mortgageApplication.MonthlyRentCurrentlyPaidByTenants"></boi-form-numeric-input>
  </ng-container>

  <ng-container *ngIf="mortgageApplication.isResidential">
    <!--211-->
    <boi-form-radio-button [optionList]='referenceDataOptionLists.AnswerType'
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [labelName]='referenceDataLabels.IsAnyPartOfThePropertyToBeLet' [propertyNames]="['IsPropertyPartToBeLetCode']"
      [(value)]='mortgageApplication.IsPropertyPartToBeLetCode'></boi-form-radio-button>
  </ng-container>

  <!--212-->
  <ng-container *ngIf="mortgageApplication.isPurchase">
    <boi-form-radio-button [optionList]='referenceDataOptionLists.AnswerType'
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [labelName]='referenceDataLabels.WillYouReceiveAnyDiscounts' [propertyNames]="['ReceiveDiscountOnPurchaseCode']"
      [(value)]='mortgageApplication.ReceiveDiscountOnPurchaseCode'></boi-form-radio-button>

    <!--212.1-->
    <ng-container *ngIf="mortgageApplication.ReceiveDiscountOnPurchaseCode === referenceDataOptionLists.AnswerTypeYes">
      <boi-form-textarea [labelName]='referenceDataLabels.PleaseProvideDetails'
        [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
        [propertyNames]="['ReceiveDiscountOnPurchaseDetails']"
        [(value)]='mortgageApplication.ReceiveDiscountOnPurchaseDetails' [fieldMaxLength]="1500"></boi-form-textarea>
    </ng-container>
  </ng-container>


  <!--43.1-->
  <ng-container *ngIf="mortgageApplication.isResidential">
    <boi-form-numeric-input [labelName]="referenceDataLabels.OtherThanTheMortgageApplicants"
      [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
      [propertyNames]="['NoPeopleAgedOver17']" [(value)]="mortgageApplication.NoPeopleAgedOver17" [fieldMaxLength]="2"
      (valueChange)="initializePropertyOccupant()" [boiDisableNumericInputIncrementation]="true"></boi-form-numeric-input>
  </ng-container>

  <ng-container *ngIf="mortgageApplication.NoPeopleAgedOver17 > 0">
    <ng-container *ngFor="let propertyOccupant of mortgageApplication.PropertyOccupants; index as occupantIndex">

      <p class="form-element subtitle-section my-15">{{referenceDataLabels.PersonId | localizeLabel}} {{occupantIndex + 1}}</p>

      <boi-form-text-input [labelName]="referenceDataLabels.NameId"
        [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
        [controlId]="referenceDataLabels.NameId + occupantIndex"
        [propertyNames]="['PropertyOccupant' + '_' + occupantIndex + '.' + 'Name']" [fieldMaxLength]="60"
        [(value)]="propertyOccupant.Name">
      </boi-form-text-input>

      <boi-form-date [labelName]="referenceDataLabels.DateOfBirthId"
        [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
        [controlId]="referenceDataLabels.DateOfBirthId + occupantIndex"
        [propertyNames]="['PropertyOccupant' + '_' + occupantIndex + '.' + 'DateOfBirth']"
        [(value)]="propertyOccupant.DateOfBirth"></boi-form-date>

      <boi-form-option-list [optionList]="referenceDataOptionLists.RelationshipType"
        [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
        [labelName]="referenceDataLabels.RelationshipToYouId"
        [controlId]="referenceDataLabels.RelationshipToYouId + occupantIndex"
        [propertyNames]="['PropertyOccupant' + '_' + occupantIndex + '.' + 'RelationshipWithApplicantCode']"
        [(value)]="propertyOccupant.RelationshipWithApplicantCode"
        (valueChange)="nullifyPropertyOccupantRelationshipDetails(propertyOccupant)"></boi-form-option-list>

      <ng-container *ngIf="isRelationshipToYouDetailsVisible(propertyOccupant)">
        <boi-form-text-input [labelName]="referenceDataLabels.PleaseProvideDetails"
          [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
          [controlId]="referenceDataLabels.PleaseProvideDetails + occupantIndex"
          [propertyNames]="['PropertyOccupant' + '_' + occupantIndex + '.' + 'RelationshipToYouDetails']"
          [(value)]="propertyOccupant.RelationshipToYouDetails" [fieldMaxLength]="1500"></boi-form-text-input>
      </ng-container>

    </ng-container>
  </ng-container>
</ng-container>

<!--130-->
<ng-container *ngIf="mortgageApplication.isBuyToLet && !mortgageApplication.isNorthernIrelandProperty">
  <boi-form-numeric-input [isCurrency]="true" [labelName]="referenceDataLabels.EstimatedUnfurnishedMonthlyRental"
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
    [propertyNames]="['EstimatedUnfurnishedMonthlyRental']"
    [(value)]="mortgageApplication.EstimatedUnfurnishedMonthlyRental" [fieldMaxLength]="5"></boi-form-numeric-input>
</ng-container>

<!--131-->
<ng-container *ngIf="mortgageApplication.isBuyToLet && mortgageApplication.isNorthernIrelandProperty">
  <boi-form-numeric-input [isCurrency]="true" [labelName]="referenceDataLabels.EstimatedFurnishedMonthlyRental"
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
    [propertyNames]="['EstimatedFurnishedMonthlyRental']"
    [(value)]="mortgageApplication.EstimatedFurnishedMonthlyRental" [fieldMaxLength]="5"></boi-form-numeric-input>
</ng-container>

<ng-container *ngIf="mortgageApplication.isBuyToLet">
  <boi-form-radio-button [optionList]='referenceDataOptionLists.AnswerType'
    [isFieldDisabled]="mortgageApplication?.IsApplicationReadOnly"
    [labelName]='referenceDataLabels.IsRentalPaidInSterlingCode' [propertyNames]="['IsRentalPaidInSterlingCode']"
    [(value)]='mortgageApplication.IsRentalPaidInSterlingCode'></boi-form-radio-button>
</ng-container>
